import React, { useEffect } from "react";
import BtnModal from "../../components/atoms/BtnModal";
import Icon from "../../components/atoms/Icon";
import { OtpUseContext } from "../../context/AdminDashboard/OtpContext";
import toast, { Toaster } from "react-hot-toast";
import Loading from "../../components/atoms/Loading";

function OTPPage() {
  // Destructuring values from OtpUseContext hook
  const {
    otp,
    handleOtpChange,
    handleOtpPaste,
    handleOtpKeyDown,
    inputRefs,
    handleSubmit,
    phoneNumber,
    loading,
  } = OtpUseContext();
// Set the document title on component mount
  useEffect(() => {
    document.title = "ویاک";
  }, []);

  return (
    <div className="flex flex-row w-full h-100">
      <div
        className="h-full w-1/4 bg-main-blue-300 bg-login-pattern bg-no-repeat flex flex-col justify-between py-12.5 px-10"
        dir="rtl">
        <Icon iconName={"Logo"} />
        <div>
          <div className="flex flex-col gap-3.6 text-white mb-16.5">
            <h1 className="text-18 font-semibold">
              داشبورد مدیریتی کارکنان ویاک
            </h1>
            <p className="text-14 font-normal leading-7">
              این صفحه اینترنتی به آدرس “admin.viaq.ir” برای استفاده عموم در
              دسترس قرار نگرفته و صرفاً برای ورود کارکنان ویاک ساخته شده است،
              تمام ترافیک این صفحه به صورت دائم رصد شده و هرگونه تلاش برای
              دسترسی غیر مجاز مورد پیگرد قانونی قرار می‌گیرد.
            </p>
          </div>
          <div className="flex flex-row gap-6 text-white text-14">
            <a href="">تماس با ما</a>
            <a href="admin.viaq.ir">ورود به صفحه اصلی سایت</a>
          </div>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div className="w-3/4 h-full ">
          <div className="flex justify-center items-center h-full flex-col">
            <div dir="rtl" className="w-auto">
              <h1 className="mb-5 text-2xl font-semibold">
                احراز هویت کاربر
              </h1>
              <p className="text-gray_L text-14 mb-8.5">
                {`لطفاً کد ورود ارسال شده برای شماره ${phoneNumber} را وارد کنید.`}
              </p>

              <div className="mb-8.5 flex   flex-row justify-between gap-2.5" dir="ltr">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    onPaste={handleOtpPaste}
                    className="w-17 h-14 text-center text-15 text-dark-blue-200 font-light rounded-lg border-2 border-gray bg-gray-chart-200 focus:outline-none focus:border-blue-500"
                    ref={(ref) => (inputRefs.current[index] = ref)}
                  />
                ))}
              </div>

              <BtnModal
                text={"تایید و ورود به داشبورد"}
                accept={handleSubmit}
                type="submit"
              />
              <div className="text-center mt-3.6 w-full text-13">
                <a href="/public">برگشت به مرحله قبل</a>
              </div>
            </div>
          </div>
          <Toaster />
        </div>
      )}
    </div>
  );
}

export default OTPPage;
